import { render } from "./LinkAccountRequestCard.vue?vue&type=template&id=5bcb0ae1&scoped=true"
import script from "./LinkAccountRequestCard.vue?vue&type=script&lang=js"
export * from "./LinkAccountRequestCard.vue?vue&type=script&lang=js"

import "./LinkAccountRequestCard.vue?vue&type=style&index=0&id=5bcb0ae1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcb0ae1"]])

export default __exports__